export default "__VITE_ASSET__Dr1tlCw2__"